var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDimension = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.78913 4.49999L12.0003 7.38445L19.2114 4.49999L12.0003 1.61554L4.78913 4.49999ZM2.49115 3.80364C1.86254 4.05508 1.86254 4.94491 2.49115 5.19635L11.7217 8.88858C11.9005 8.9601 12.1 8.9601 12.2788 8.88858L21.5094 5.19635C22.138 4.94491 22.138 4.05508 21.5094 3.80364L12.2788 0.111412C12.1 0.0398892 11.9005 0.0398887 11.7217 0.111412L2.49115 3.80364ZM14.25 11.4891V21.7252L21.75 18.5109V8.27479L14.25 11.4891ZM13.2046 10.3052C12.9288 10.4234 12.75 10.6945 12.75 10.9945V22.8626C12.75 23.401 13.3005 23.764 13.7954 23.5519L22.7954 19.6948C23.0712 19.5766 23.25 19.3055 23.25 19.0054V7.13738C23.25 6.59895 22.6995 6.23592 22.2046 6.44803L13.2046 10.3052ZM2.25 18.5109V8.27479L9.75 11.4891V21.7252L2.25 18.5109ZM0.75 7.13738C0.75 6.59895 1.30054 6.23592 1.79544 6.44803L10.7954 10.3052C11.0712 10.4234 11.25 10.6945 11.25 10.9945V22.8626C11.25 23.401 10.6995 23.764 10.2046 23.5519L1.20456 19.6948C0.928798 19.5766 0.75 19.3055 0.75 19.0054V7.13738Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDimension);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/dimension.c61465ac8f0339efa8a2103015f2bdf9.svg";